// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3XRsM","left":"StickyBox_left__24UA7","right":"StickyBox_right__12eDp"};